import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    personalGuarantor: {
        id: '_.your_company.personal_guarantor',
        defaultMessage: 'Personal guarantor'
    },
    personalGuarantorEdit: {
        id: '_.your_company.personal_guarantor_edit',
        defaultMessage: 'Edit'
    },
    applicant: {
        id: '_.your_company.applicant',
        defaultMessage: 'Applicant'
    },
    guarantor: {
        id: '_.your_company.guarantor',
        defaultMessage: 'Guarantor'
    },
    director: {
        id: '_.your_company.director',
        defaultMessage: 'Director'
    },
    shareholder: {
        id: '_.your_company.shareholder',
        defaultMessage: 'Shareholder'
    },
    partner: {
        id: '_.your_company.partner',
        defaultMessage: 'Partner'
    },
    beneficial_owner: {
        id: '_.your_company.beneficial_owner',
        defaultMessage: 'Beneficial owner'
    },
    other: {
        id: '_.your_company.other',
        defaultMessage: 'Other'
    }
});
